<template>
	<div class='main-mybody'>
		<a-row>
			<a-col :span='12'>
				<a-col :span='19'>
					<div class='look_g'><div></div>個人基本資料</div>
					<a-row><a-col :span='10'>中文名稱</a-col><a-col :span='14'>{{lookfrom.name_cn}}</a-col></a-row>
					<a-row><a-col :span='10'>英文名稱</a-col><a-col :span='14'>{{lookfrom.name_en}}</a-col></a-row>
					<a-row><a-col :span='10'>出生日期</a-col><a-col :span='14'>{{lookfrom.birth}}</a-col></a-row>
					<a-row><a-col :span='10'>性別</a-col><a-col :span='14'>{{lookfrom.sex==2?'女':lookfrom.sex==1?'男':''}}</a-col></a-row>
					<a-row><a-col :span='10'>婚姻狀況</a-col><a-col :span='14'>{{lookfrom.ismarryed==1?'已婚':lookfrom.ismarryed==2?'未婚':''}}</a-col></a-row>
					<a-row><a-col :span='10'>國籍</a-col><a-col :span='14'>{{lookfrom.nationality}}</a-col></a-row>
					<div class='main-wid'></div>
				</a-col>
				<a-col :span='19'>
					<div class='look_g'><div></div>聯絡資料</div>
					<a-row><a-col :span='10'>工作電子郵箱地址</a-col><a-col :span='14'>{{lookfrom.email}}</a-col></a-row>
					<a-row><a-col :span='10'>工作電話號碼</a-col><a-col :span='14'>{{lookfrom.phone}}</a-col></a-row>
					<a-row><a-col :span='10'>手機號碼</a-col><a-col :span='14'>{{lookfrom.telphone}}</a-col></a-row>
					<a-row><a-col :span='10'>住宅地址</a-col><a-col :span='14'>{{lookfrom.homeaddress}}</a-col></a-row>
					<div class='main-wid'></div>
				</a-col>
				<a-col :span='19'>
					<div class='look_g'><div></div>工作地址</div>
					<a-row><a-col :span='10'>營業地址</a-col><a-col :span='14'>{{lookfrom.business_area}}</a-col></a-row>
					<a-row><a-col :span='10'>地址</a-col><a-col :span='14'>{{lookfrom.address}}</a-col></a-row>
					<a-row><a-col :span='10'>城市</a-col><a-col :span='14'> {{lookfrom.city}}</a-col></a-row>
					<a-row><a-col :span='10'>國家/地區/州</a-col><a-col :span='14'> {{lookfrom.country_area_state}}</a-col></a-row>
					<a-row><a-col :span='10'>郵政編號</a-col><a-col :span='14'>{{lookfrom.postcode}}</a-col></a-row>
				</a-col>
			</a-col>
			<a-col :span='12'>
				<a-col :span='19'>
					<div class='look_g'><div></div>公司資料</div>
					<a-row><a-col :span='10'>公司名稱</a-col><a-col :span='14'>{{lookfrom.company_name}}</a-col></a-row>
					<a-row><a-col :span='10'>公司的國家/地區代碼</a-col><a-col :span='14'>{{lookfrom.country_code}}</a-col></a-row>
					<a-row><a-col :span='10'>使用者部門/職位</a-col><a-col :span='14'>{{lookfrom.department+'/'+lookfrom.job}}</a-col></a-row>
					<a-row><a-col :span='10'>員工編碼</a-col><a-col :span='14'>{{lookfrom.employee_number}}</a-col></a-row>
					<div class='main-wid'></div>
				</a-col>
				<a-col :span='19'>
					<div class='look_g'><div></div>緊急聯絡</div>
					<a-row><a-col :span='10'>聯絡人姓名</a-col><a-col :span='14'>{{lookfrom.emergency_name}}</a-col></a-row>
					<a-row><a-col :span='10'>聯絡人電話</a-col><a-col :span='14'>{{lookfrom.emergency_phone}}</a-col></a-row>
					<div class='main-wid'></div>
				</a-col>
				<a-col :span='19'>
					<div class='look_g'><div></div>個人偏好</div>
					<a-row><a-col :span='10'>偏好的語言</a-col><a-col :span='14'>{{lookfrom.language_love}}</a-col></a-row>
					<a-row><a-col :span='10'>偏好的時區</a-col><a-col :span='14'>{{lookfrom.timezone_love}}</a-col></a-row>
					<div class='main-wid'></div>
				</a-col>
			</a-col>
		</a-row>
	</div>
</template>

<script>
	export default {
		props:['lookfrom'],
		watch:{
			lookfrom:{
				deep:true,
				handler(ev){
					if(ev){
						console.log(this.lookfrom)
					}
				}
			}
		}
	}
</script>

<style>
</style>
